import { useAuthContext } from "features/auth/AuthContext";
import { UserRole } from "features/auth/types/user";
import { Navigate, Outlet } from "react-router-dom";

type AuthRouteProps = {
  roles?: UserRole[];
};

const AuthRoute: React.FC<AuthRouteProps> = ({ roles }) => {
  const { user } = useAuthContext();

  const hasPermission = (): boolean => {
    if (!roles) {
      return true;
    } else {
      return roles.includes(user?.role ? user?.role : UserRole.NONE);
    }
  };

  if (!user) return <Navigate to="/" />;
  if (!hasPermission()) return <Navigate to="/" />;

  return <Outlet />;
};

export default AuthRoute;
